/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { Card } from "@mui/material";
// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import PageNavbar from "components/PageNavbar";

// React icons
import { IoCalendar } from "react-icons/io5";

// Configure your iframe URL here
const IFRAME_URL = "https://attendancev2.zainlee.com/demo";

function Attendance() {
  return (
    <DashboardLayout>
      <PageNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card sx={{ height: "calc(100vh - 150px)", overflow: "hidden" }}>
                <VuiBox 
                  p={2} 
                  display="flex" 
                  alignItems="center" 
                  sx={{ 
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    background: "linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.49) 76.65%)"
                  }}
                >
                  <IoCalendar size="24px" color="#FFA500" style={{ marginRight: "12px" }} />
                  <VuiTypography variant="h5" color="white" fontWeight="bold">
                    Attendance
                  </VuiTypography>
                </VuiBox>
                <VuiBox 
                  sx={{ 
                    width: "100%", 
                    height: "calc(100% - 64px)",
                    position: "relative",
                    overflow: "hidden"
                  }}
                >
                  <iframe
                    src={IFRAME_URL}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      display: "block"
                    }}
                    title="Attendance Interface"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; geolocation; fullscreen"
                  />
                </VuiBox>
              </Card>
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Attendance;

